export const projeler = {
    title: 'Projeler',
    titleEN: 'Projects',
    description: 'Yemek.com\'da yayınlanan tarifler ve öneriler dışında, mutfak kültürünü zenginleştirmek, sağlıklı ve lezzetli yemekleri tanıtmak amacıyla oluşturulan içeriklerdir.',
    descriptionEN: 'These are contents created to enrich culinary culture and introduce healthy and delicious meals, beyond the recipes and recommendations published on Yemek.com.',
    tabs: [
        {
            id: 1,
            title: 'Projeler',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/091409e703e93a2bb0fbc9a6b4350d275e4a5b133496e8bc7392c34bdb2e8f27.png',
                    category: 'TİB Ramazan',
                    url: 'https://www.figma.com/proto/JcOxcLg7E1aDPofgecgodo/T%C4%B0B-Ramazan-Masthead-Int.?page-id=1%3A2&node-id=1-2534&viewport=362%2C484%2C0.35&t=66Q9qi7YvW0j87g9-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=3%3A5473'
                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/811d5c21ca4390a2da2efd206ac507a836acc195146126aced4d227c81ab85c5.png',
                    modal: 'image',
                    category: 'Superfresh To'
                },
                {
                    id: 3,
                    image: 'https://srv-cdn.onedio.com/store/2875eff79da0806703dba848719b92b42d2d583675f98e4543aa8b312188754d.png',
                    category: 'Superfresh MH',
                    url: 'https://yemek.com/?google_preview=af2XdEwzTWgYrpe4yAYwrrPtzwaIAYCAgJCyjeOpLQ&iu=21814681&gdfp_req=1&lineItemId=6907374687&creativeId=138505955276'
                }
            ]
        },
    ],
    egTabs: [
        {
            id: 1,
            title: 'Projects',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/091409e703e93a2bb0fbc9a6b4350d275e4a5b133496e8bc7392c34bdb2e8f27.png',
                    url: 'https://www.figma.com/proto/JcOxcLg7E1aDPofgecgodo/T%C4%B0B-Ramazan-Masthead-Int.?page-id=1%3A2&node-id=1-2534&viewport=362%2C484%2C0.35&t=66Q9qi7YvW0j87g9-1&scaling=scale-down-width&content-scaling=fixed&starting-point-node-id=3%3A5473',
                    category: 'TİB Ramazan',


                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/811d5c21ca4390a2da2efd206ac507a836acc195146126aced4d227c81ab85c5.png',
                    modal: 'image',
                    category: 'Superfresh To'

                },
                {
                    id: 3,
                    image: 'https://srv-cdn.onedio.com/store/2875eff79da0806703dba848719b92b42d2d583675f98e4543aa8b312188754d.png',
                    category: 'Superfresh MH',
                    url: 'https://yemek.com/?google_preview=af2XdEwzTWgYrpe4yAYwrrPtzwaIAYCAgJCyjeOpLQ&iu=21814681&gdfp_req=1&lineItemId=6907374687&creativeId=138505955276'

                }
            ]
        },
    ]
} 